<template>
  <vx-card title="Venues List">
    <vs-table pagination :max-items="itemsPerPage" :data="venues" search>
      <div
        v-if="addAllowed == true"
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <div
            class="
              mr-auto
              px-4
              w-full
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgCl asses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th>Name</vs-th>
        <vs-th>Street</vs-th>
        <vs-th>Today</vs-th>
        <vs-th>This Week</vs-th>
        <vs-th>This Month</vs-th>
        <vs-th>Wallet Amount</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.name">{{ tr.name }}</vs-td>
          <vs-td :data="tr.street">{{ tr.street }}</vs-td>
          <vs-td :data="tr.today_bookings_count">{{
            tr.today_bookings_count
          }}</vs-td>
          <vs-td :data="tr.week_bookings_count">{{
            tr.week_bookings_count
          }}</vs-td>
          <vs-td :data="tr.month_bookings_count">{{
            tr.month_bookings_count
          }}</vs-td>
          <vs-td :data="tr.wallet_amount">{{ tr.wallet_amount }}</vs-td>
          <vs-td class="whitespace-no-wrap">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
              v-show="editAllowed"
              @click.stop="editData(tr.id)"
            />
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.stop="deleteData(tr)"
            />
            <feather-icon
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.stop="showData(tr.id)"
              v-show="showAllowed"
            />
            <!-- <feather-icon icon="PlusIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="showData(tr.id)" /> -->
          </vs-td>
        </vs-tr>

      </template>
    </vs-table>


    <vs-popup title="Select portal " :active.sync="portalChoicePopup">
      <portal-types @selectPortalType="setPortalType" />

      <!-- this popup is used in case of online and delivery selection  -->
      <vs-popup
        :title="'Add ' + portal.type + ' Portal'"
        :active.sync="onlinePortalPopup"
      >
        <online-delivery-portal
          :role-options="roleOptions"
          @addParentPortal="updatePortalUI"
        />
      </vs-popup>

      <vs-popup title="Add New Device" :active.sync="devicePortalPopup">
        <online-delivery-portal
          :role-options="roleOptions"
          @addParentPortal="updatePortalUI"
        />
      </vs-popup>

      <vs-popup title="Add API Portal" :active.sync="apiPortalPopup">
        <api-portal @addParentPortal="updatePortalUI" />
      </vs-popup>

      <vs-popup class="text-center" title="QR Booker" :active.sync="qrPopup">
        <div class="append-text btn-addon">
          <vs-button type="border" @click="generateQR" class="whitespace-no-wrap">Generate QR Code</vs-button>
          <vs-button type="border" @click="removeQR" class=" ml-2 whitespace-no-wrap">Remove QR Code</vs-button>
        </div>

        <img class="mt-4" v-if="venue_qr_exists" :src="main_domain+'/qrcodes/venue-'+venueIndex+'.svg'" alt="">
      </vs-popup>
    </vs-popup>
    <vs-popup
      :title="'Edit ' + portal.type + ' Portal'"
      :active.sync="editOnlinePortalPopup"
    >
      <online-delivery-portal
        :role-options="roleOptions"
        @updateParentPortal="updatePortalUI"
      />
    </vs-popup>

    <vs-popup
      :title="'Edit Device Settings'"
      :active.sync="editDevicePortalPopup"
    >
      <portal-settings
        @updateConfigParent="updatePortalSettings"
      ></portal-settings>
    </vs-popup>
  </vx-card>
</template>

<script>
import {
  _list,
  _delete,
  _deletePortal,
  _updatePortalSettings,
  _generateQR,
  _removeQR
} from "@/services/Venue";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import PortalTypes from "./PortalTypesPopup";
import OnlineDeliveryPortal from "./OnlineDelivery";
import PortalSettings from "./PortalSettings";
import ApiPortal from "./ApiPortal";
import modulePortal from "@/store/portal/modulePortalManagement.js";
import { _permissions } from "@/services/Portal";
import { _update_user_status } from "@/services/User";
import { MAIN_DOMAIN } from '@/environment'


const dict = {
  custom: {
    portal_username: {
      required: "Please enter username",
    },
    portal_password: {
      required: "Please enter password",
    },
    portal_role: {
      required: "Please select role",
    },
    portal_device: {
      required: "Please enter device address",
    },
  },
};

Validator.localize("en", dict);

export default {
  components: {
    vSelect,
    PortalTypes,
    OnlineDeliveryPortal,
    PortalSettings,
    ApiPortal,
  },
  mounted() {
    this.$store.registerModule("portalModule", modulePortal);
  },
  beforeDestroy: function () {
    this.$store.unregisterModule("portalModule");
  },
  data() {
    return {
      companyID: this.$store.state.company.companyID,
      venues: [],
      itemsPerPage: 9,
      portalChoicePopup: false,
      onlinePortalPopup: false,
      devicePortalPopup: false,
      apiPortalPopup: false,
      qrPopup: false,
      editOnlinePortalPopup: false,
      editDevicePortalPopup: false,
      roleOptions: [
        { label: "Basic", value: "basic" },
        { label: "Reception", value: "reception" },
        { label: "Kiosk", value: "kiosk" },
      ],
      venueIndex: -1,
      allPortals: [],
      main_domain : MAIN_DOMAIN,
      venue_qr_exists: false

    };
  },
  computed: {
    // venue_qr_exists() {
    //   return this.selVen.qr_exists;
    // },
    selVen(){
          const selectedVenueIndex = this.venues.findIndex(
              (v) => v.id == this.venueIndex
            );
            return this.venues[selectedVenueIndex];
            // selectedVen.qr_exists = true;
    },
    portal: {
      get() {
        return this.$store.state.portalModule;
      },
    },
    itemColor() {
      return (obj) => {
        let style_obj = {}

        obj.style.forEach(p => { style_obj[p] = obj.color })

        return style_obj
      }
    },
    addAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;

      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/venue/add"))) {
          return true;
        }
        return false;
      }
    },
    editAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;
      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/venue/edit"))) {
          return true;
        }
        return false;
      }
    },
    showAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;
      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/venue/view"))) {
          return true;
        }
        return false;
      }
    },
  },
  watch: {
    "$store.state.company.companyID"(val) {
      this.companyID = val;
      this.getVenues();
    },
  },
  created() {
    this.getVenues();
  },
  methods: {
    listen() {
      this.$echo
        .join("taxipoint")
        .here((users) => {
          const onlineUsers = users.filter(
            (u) =>
              u.id !== this.$store.state.AppActiveUser.uid &&
              u.status === "offline"
          );
          onlineUsers.map((o) => {
            let model = this.allPortals.find((p) => p.user_id == o.id);
            if (model) {
              let v_idx = this.venues.findIndex((v) => v.id === model.venue_id);
              let selectedVenuePortals = this.venues[v_idx].portals;
              let p_idx = selectedVenuePortals.findIndex(
                (p) => p.user_id === o.id
              );
              let v_portal = selectedVenuePortals[p_idx];
              if (v_portal) {
                v_portal.user.status = "online";
              }
              this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
            }
          });
        })
        .joining((user) => {
         this.portalJoined(user);
        })
        .leaving((user) => {
          this.portalLeft(user);
        });
    },
    portalJoined(user) {
      let model = this.allPortals.find((p) => p.user_id === user.id); // get portal model
      let v_idx = this.venues.findIndex((v) => v.id === model.venue_id); // get venue index from portal model
      let selectedVenuePortals = this.venues[v_idx].portals; // get selected venue to update further
      let p_idx = selectedVenuePortals.findIndex((p) => p.user_id === user.id);
      let v_portal = selectedVenuePortals[p_idx]; // get portal to update
      if (v_portal) {
        v_portal.user.status = "online";
        _update_user_status(v_portal.user.id, { status: "online" }); // calling api
        this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
      }
    },
    portalLeft(user) {
      let model = this.allPortals.find((p) => p.user_id === user.id); // get portal model
      let v_idx = this.venues.findIndex((v) => v.id === model.venue_id); // get venue index from portal model
      let selectedVenuePortals = this.venues[v_idx].portals; // get selected venue to update further
      let p_idx = selectedVenuePortals.findIndex((p) => p.user_id === user.id);
      let v_portal = selectedVenuePortals[p_idx]; // get portal to update
      if (v_portal) {
        v_portal.user.status = "offline";
        _update_user_status(v_portal.user.id, { status: "offline" }); // calling api
        this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
      }
    },
    getVenues() {
      this.$vs.loading();
      _list(this.companyID)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venues = response.data.obj.list;
            this.allPortals = this.venues.flatMap((el) => el.portals);
            this.listen();
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    addNewData() {
      this.$router.push("/venue/add");
    },
    showData(id) {
      this.$router.push(`/venue/view/${id}`);
    },
    deleteData(tr) {
      this.deleteIndex = tr.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `You are about to delete "${tr.display_name}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    deleteRecord() {
      let id = this.deleteIndex;
      this.$vs.loading();
      _delete(id)
        .then((response) => {
          this.$vs.loading.close();
          let data = this.venues.filter((p) => p.id != id);
          this.venues = data;
          this.$vs.notify({
            title: response.data.responseTitle,
            text: response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    editData(id) {
      this.$router.push(`/venue/edit/${id}`);
    },
    setVenueIndex(venueID) {
      this.portalChoicePopup = true;
      this.venueIndex = venueID;
      this.venue_qr_exists = this.selVen.qr_exists == 1 ? true:false
    },
    setPortalType(portalType) {
      this.errors.clear();
      if (portalType == "online") {
        this.portal.role = { label: "Basic", value: "basic" };
        this.onlinePortalPopup = true;
      } else if (portalType == "device") this.devicePortalPopup = true;
      else if (portalType == "delivery") {
        this.portal.role = { label: "Delivery", value: "delivery" };
        this.onlinePortalPopup = true;
      } else if (portalType == "api") {
        this.apiPortalPopup = true;
      }  else if (portalType == "qR-booker")
      {
        this.qrPopup = true;

      }
      this.$store.dispatch("portalModule/updatePortal", {
        type: portalType,
        venue_id: this.venueIndex,
        role: this.portal.role,
      });
      this.$store.dispatch("portalModule/setPortalPermission", {
        permissions: "",
      });
    },
    updatePortalUI(response, calltype = "add") {
      let localPortal = response.data.obj.portal;
      if (calltype == "edit") {
        this.updatePortalRow(localPortal);
        this.editOnlinePortalPopup = false;
        this.apiPortalPopup = false;
      } else {
        const selectedVenue = this.venues.find(
          (venue) => venue.id == localPortal.venue_id
        );
        if (selectedVenue) {
          selectedVenue.portals.push(localPortal);
        }
        this.onlinePortalPopup = false;
        this.devicePortalPopup = false;
        this.apiPortalPopup = false;
        this.portalChoicePopup = false;
      }
      this.$store.dispatch("portalModule/resetPortal");
    },

    editPortal(val) {
      if (val.type == "api") {
        // get portal permissions
        _permissions(val.id).then((res) => {
          this.$store.dispatch(
            "portalModule/setPortalPermission",
            res.data.obj
          );
        });
      }
      this.errors.clear();
      let localRole = {};
      switch (val.role) {
        case "delivery":
          localRole = { label: "delivery", value: "delivery" };
          break;
        case "basic":
          localRole = { label: "Basic", value: "basic" };
          break;
        case "reception":
          localRole = { label: "Reception", value: "reception" };
          break;
        case "kiosk":
          localRole = { label: "Kiosk", value: "kiosk" };
          break;
        default:
          break;
      }

      this.$store.dispatch("portalModule/updatePortal", {
        id: val.id,
        device_id: val.device_id,
        username: val.user.api_username,
        password: val.user.api_password,
        type: val.type,
        duration: val.duration,
        venue_id: val.venue_id,
        config: val.config,
        role: localRole,
        customer_id: val.user.customer_id,
        capabilities: val.capabilities,
      });
      this.venueIndex = val.venue_id;
      if (val.type == "device") {
        this.editDevicePortalPopup = true;
      } else if (val.type == "api") {
        this.apiPortalPopup = true;
      } else {
        this.editOnlinePortalPopup = true;
      }
    },
    deletePortal(val) {
      this.$vs.loading();
      _deletePortal(val.venue_id, val.id)
        .then(
          (response) => {
            this.$vs.loading.close();
            const selectedVenueIndex = this.venues.findIndex(
              (v) => v.id == val.venue_id
            );
            const selectedVen = this.venues[selectedVenueIndex];
            const selectedPortalIndex = selectedVen.portals.findIndex(
              (p) => p.id == val.id
            );
            this.venues[selectedVenueIndex].portals.splice(
              selectedPortalIndex,
              1
            );
            this.$vs.notify({
              title: response.data.responseTitle,
              text: response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    updatePortalSettings(response) {
      this.updatePortalRow(response.data.obj.portal);
      this.editDevicePortalPopup = false;
      this.venueIndex = -1;
      this.$store.dispatch("portalModule/resetPortal");
    },

    updatePortalRow(localPortal) {
      const selectedVenueIndex = this.venues.findIndex(
        (v) => v.id == localPortal.venue_id
      );
      const selectedVen = this.venues[selectedVenueIndex];
      const selectedPortalIndex = selectedVen.portals.findIndex(
        (p) => p.id == localPortal.id
      );
      this.$set(
        this.venues[selectedVenueIndex].portals,
        selectedPortalIndex,
        localPortal
      );
    },
    generateQR() {
      this.$vs.loading();
      _generateQR(this.venueIndex)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venue_qr_exists =  true
            this.selVen.qr_exists = 1;
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

 removeQR() {
      this.$vs.loading();
      _removeQR(this.venueIndex)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venue_qr_exists =  false
            this.selVen.qr_exists = 0


          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

  },
};
</script>
